export { default as SortableMultiValueRemove } from './SortableMultiValueRemove';
